<mat-form-field appearance="outline" class="w-100">
  <mat-label>Service Line</mat-label>
  <mat-select [formControl]="control" multiple>
    <mat-option *ngFor="let sl of serviceLines" [value]="sl.id">
      {{ sl.codigo }} - {{ sl.nombre }}
    </mat-option>
  </mat-select>
</mat-form-field>
